// navData.js

/* ================= NAV LINKS ================= */
export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Registration", dropdown: "registration" },
  { name: "Our Services", dropdown: "services" },
  { name: "Advisory", dropdown: "advisory" },
  { name: "Contact", path: "/contact" },
];

/* =====================================================
   REGISTRATION SERVICES
===================================================== */
export const registrationServices = [
  {
    name: "Company Registration Services",
    path: "/registration/company-registration-services",
    subItems: [
      { name: "Company Registration", path: "/company-registration" },
      { name: "Private Limited Company Registration", path: "/private-limited-company-registration" },
      { name: "LLP Registration", path: "/llp-registration" },
      { name: "Public Limited Company Registration", path: "/public-limited-company-registration" },
      { name: "One Person Company (OPC) Registration", path: "/one-person-company-registration" },
      { name: "Indian Subsidiary Registration", path: "/indian-subsidiary-registration" },
      { name: "Foreign Subsidiary Company Registration", path: "/foreign-subsidiary-registration" },
      { name: "Foreign Company Registration in India", path: "/foreign-company-registration-india" },
      { name: "Producer Company Registration", path: "/producer-company-registration" },
      { name: "Nidhi Company Registration", path: "/nidhi-company-registration" },
      { name: "Virtual Office Registration", path: "/virtual-office-registration" },
      { name: "Wordmark Registration", path: "/wordmark-registration" },
      { name: "Barcode Registration", path: "/barcode-registration" }
    ]
  },

  {
    name: "Government Registration Services",
    path: "/registration/government-services",
    subItems: [
      { name: "Drug License", path: "/drug-license" },
      { name: "Liquor License", path: "/liquor-license" },
      { name: "Ayush License", path: "/ayush-license" },
      { name: "Factory License", path: "/factory-license" },
      { name: "Petrol Pump License", path: "/petrol-pump-license" },
      { name: "Tobacco License", path: "/tobacco-license" },
      { name: "ICEGATE Registration", path: "/icegate-registration" },
      { name: "RCMC Registration", path: "/rcmc-registration" },
      { name: "SPICe+ Form Filing", path: "/spice-form-filing" },
      { name: "ISO Certification", path: "/iso-certification" },
      { name: "ISO 9001 Certification", path: "/iso-9001" },
      { name: "ISO 14001 Certification", path: "/iso-14001" },
      { name: "ISO 22000 FSMS Certification", path: "/iso-22000" },
      { name: "ISO 27001 Certification", path: "/iso-27001" },
      { name: "ISO 31000 Certification", path: "/iso-31000" },
      { name: "ISO 50001 Certification", path: "/iso-50001" },
      { name: "ISI Mark Certification", path: "/isi-mark" },
      { name: "GMP Certification", path: "/gmp-certification" },
      { name: "FIEO Registration", path: "/fieo-registration" },
      { name: "DUNS Number Registration", path: "/duns-registration" }
    ]
  },

  {
    name: "FSSAI Registration Services",
    path: "/registration/fssai-services",
    subItems: [
      { name: "FSSAI Registration", path: "/fssai-registration" },
      { name: "FSSAI State License", path: "/fssai-state-license" },
      { name: "FSSAI Central License", path: "/fssai-central-license" },
      { name: "FSSAI Product Approval", path: "/fssai-product-approval" },
      { name: "FSSAI License Renewal", path: "/fssai-license-renewal" },
      { name: "Halal Certification", path: "/halal-certification" }
    ]
  },

  {
    name: "Trade License Services",
    path: "/registration/trade-license",
    subItems: [
      { name: "Trade License", path: "/trade-license" },
      { name: "Gumasta License", path: "/gumasta-license" }
    ]
  },

  {
    name: "Business Certification Services",
    path: "/registration/business-certification",
    subItems: [
      { name: "RERA Registration", path: "/rera-registration" },
      { name: "NSIC Registration", path: "/nsic-registration" },
      { name: "PESO Certificate", path: "/peso-certificate" },
      { name: "Hallmark Registration", path: "/hallmark-registration" },
      { name: "BEE Registration", path: "/bee-registration" },
      { name: "Make in India Certificate", path: "/make-in-india" },
      { name: "ZED Certification", path: "/zed-certification" },
      { name: "APEDA Registration", path: "/apeda-registration" },
      { name: "TEXPROCIL Registration", path: "/texprocil-registration" },
      { name: "Certificate of Good Standing", path: "/good-standing-certificate" },
      { name: "CE Certification", path: "/ce-certification" }
    ]
  },

  {
    name: "Business License Services",
    path: "/registration/business-license",
    subItems: [
      { name: "RNI Registration", path: "/rni-registration" },
      { name: "CDSCO Registration", path: "/cdsco-registration" },
      { name: "AD Code Registration", path: "/ad-code-registration" },
      { name: "GSP Registration", path: "/gsp-registration" },
      { name: "SAFTA License", path: "/safta-license" },
      { name: "WPC Certificate", path: "/wpc-certificate" },
      { name: "AGMARK License Registration", path: "/agmark-license" }
    ]
  },

  {
    name: "BIS Registration Services",
    path: "/registration/bis-services",
    subItems: [
      { name: "BIS Certification", path: "/bis-certification" },
      { name: "BIS FMCS Certification", path: "/bis-fmcs" }
    ]
  },

  {
    name: "International Business Setup",
    path: "/registration/international-setup",
    subItems: [
      { name: "Company Registration in Dubai", path: "/dubai-company-registration" },
      { name: "Dubai Free Zone Company Registration", path: "/dubai-free-zone" },
      { name: "UK Company Registration", path: "/uk-company-registration" },
      { name: "Singapore Company Registration", path: "/singapore-company-registration" },
      { name: "USA Company Registration", path: "/usa-company-registration" }
    ]
  }
];

/* =====================================================
   OUR SERVICES
===================================================== */
export const serviceCategories = [
  {
    name: "Compliance",
    subItems: [
      { name: "MSME Registration", path: "/msme-registration" },
      { name: "EPF Registration", path: "/epf-registration" },
      { name: "Shop & Establishment Registration", path: "/shop-establishment-registration" }
    ]
  },

  {
    name: "Annual Compliance",
    subItems: [
      { name: "LLP Annual Compliance", path: "/llp-annual-compliance" },
      { name: "Annual Compliance for Private Limited Company", path: "/private-limited-annual-compliance" },
      { name: "Book Keeping and Accounting Services", path: "/bookkeeping-accounting" },
      { name: "Nidhi Company Compliance", path: "/nidhi-company-compliance" }
    ]
  },

  {
    name: "MCA Services",
    subItems: [
      { name: "Appointment of Auditor", path: "/appointment-of-auditor" },
      { name: "Form INC-20A", path: "/inc-20a-filing" },
      { name: "Change Private Limited Company Name", path: "/change-company-name" },
      { name: "Change in Registered Office", path: "/change-registered-office" },
      { name: "Change in Object Clause", path: "/change-object-clause" },
      { name: "Revival of Struck Off Companies", path: "/revival-of-company" },
      { name: "Change in Director", path: "/change-director" },
      { name: "DIR-3 KYC for Directors", path: "/dir-3-kyc" }
    ]
  },

  {
    name: "Trademark Registration",
    subItems: [
      { name: "Trademark Registration", path: "/trademark-registration" },
      { name: "Trademark Renewal", path: "/trademark-renewal" },
      { name: "Trademark Objection", path: "/trademark-objection" },
      { name: "Trademark Opposition", path: "/trademark-opposition" }
    ]
  },

  {
    name: "Income Tax",
    subItems: [
      { name: "Income Tax Return Filing", path: "/income-tax-return" },
      { name: "TDS Return Filing", path: "/tds-return" },
      { name: "ITR 1 Filing", path: "/itr-1" },
      { name: "ITR 2 Filing", path: "/itr-2" }
    ]
  },

  {
    name: "Goods & Services Tax (GST)",
    subItems: [
      { name: "GST Registration", path: "/gst-registration" },
      { name: "GST Return Filing", path: "/gst-return-filing" },
      { name: "GSTR-9 Return", path: "/gstr-9" },
      { name: "Input Tax Credit", path: "/input-tax-credit" }
    ]
  },

  {
    name: "CA Services",
    subItems: [
      { name: "Online Chartered Accountant Services", path: "/online-ca" },
      { name: "Financial Consultancy Services", path: "/financial-consultancy" }
    ]
  }
];

/* ================= ADVISORY ================= */
export const advisoryServices = [
  { name: "Cooperative Banking Sector Advisory", path: "/advisory/cooperative-banking" },
  { name: "Tender Related Advisory Services", path: "/advisory/tender-bid" },
  { name: "Wealth Management Advisory", path: "/advisory/wealth-management" },
  { name: "Consultancy Advisory", path: "/advisory/strategy-management" },
  { name: "Government & Infrastructure Advisory", path: "/advisory/government-infrastructure" }
];
